import { hasPermissionAjustes } from '@/service/api'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { z } from 'zod'
import { ReprovarService as useService } from '../../service/reprovar'

const ReprovarAjusteModal: React.FC = () => {
    const { handleSubmit, isLoading } = useService()

    return (
        <Dialog.Root
            open={hasPermissionAjustes()}
            height="auto"
            width="32rem"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={z.object({
                motivo: z
                    .string()
                    .trim()
                    .min(1, 'Justificativa é obrigatório')
                    .max(150),
            })}
        >
            <Dialog.Title>Reprovar ajuste</Dialog.Title>
            <Dialog.Content dividers>
                <FormField
                    name="motivo"
                    label="Justificativa"
                    multiline
                    rows={2}
                    required
                    InputProps={{
                        inputProps: {
                            maxLength: 150,
                        },
                    }}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default ReprovarAjusteModal
